// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__vbS7h","header":"PatientBlock_header__KHtjM","label":"PatientBlock_label__1-9g7","option":"PatientBlock_option__15n5b"};